import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { CATALOG_QUERY } from './useModelsQuery';
import type { CatalogModel, Modality, ModelCatalogResponse } from '@/types';

export function useCatalogModels(modality?: Modality): UseQueryResult<CatalogModel[], Error> {
  return useQuery({
    ...CATALOG_QUERY,
    select: (d: ModelCatalogResponse) =>
      modality ? d.models.filter((m) => m.capability.modality === modality) : d.models,
  });
}
